(function () {
  "use strict";

  const dataNode = document.querySelector("[data-joye-lens-upgrade-variants]");
  let variants = [];

  if (dataNode) {
    try {
      variants = JSON.parse(dataNode.textContent || "[]");
    } catch (error) {
      console.error("Unable to read Lens Upgrade variants.", error);
    }
  }

  const availableByPrice = new Map();
  variants.forEach((variant) => {
    const record = {
      id: Number(variant.id),
      price: Number(variant.price),
      available: Boolean(variant.available)
    };
    if (record.id && Number.isFinite(record.price) && record.available) {
      availableByPrice.set(record.price, record);
    }
  });

  function variantForPrice(price) {
    const cents = Math.round(Number(price) * 100);
    if (!Number.isFinite(cents)) return null;
    return availableByPrice.get(cents) || null;
  }

  window.__joyeLensUpgradeVariantForPrice = variantForPrice;
  window.__joyeLensUpgradeVariantIdForPrice = function (price) {
    const variant = variantForPrice(price);
    return variant ? variant.id : null;
  };
})();
